import styles from './Styles.module.scss'
import CloseButton from "./CloseButton";

function InfoBlock({text, isVisible, onClose}) {
    return (<div className={`${styles.infoBlock} ${isVisible ? styles.visible : ''}`}>
        <CloseButton onClick={onClose} style={{top: '2px', right: '2px'}}/>
        <span>{text}</span>
    </div>)
}

export default InfoBlock;